var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            direction: "rtl",
            size: "50%",
            "modal-append-to-body": false,
            "before-close": _vm.onCancel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.form
            ? _c("BjDivider", [
                _vm._v(
                  _vm._s(
                    _vm.form.id
                      ? _vm.$t("billingPage.updateProfile")
                      : _vm.$t("billingPage.createProfile")
                  )
                ),
              ])
            : _vm._e(),
          _vm.drawer
            ? _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    disabled: _vm.formDisable,
                    "label-width": "180px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.boundUser"),
                        prop: "clientCode",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          clearable: false,
                          "option-list": _vm.clientCodeList,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.form.clientCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "clientCode", $$v)
                          },
                          expression: "form.clientCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.effectiveDate") + ":",
                        prop: "effectiveDate",
                      },
                    },
                    [
                      _c("BjDatePicker", {
                        model: {
                          value: _vm.form.effectiveDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "effectiveDate", $$v)
                          },
                          expression: "form.effectiveDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("billingPage.description") + ":" },
                    },
                    [
                      _c("BjInput", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("inputText"),
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: _vm.MAX_LENGTH.BILLMAX,
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.billingProfileTemplate"),
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "main-btn",
                          attrs: { type: "primary" },
                          on: { click: _vm.choseCategories },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("billingPage.ChoseProfileTemplate"))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.form.categoryCodes && _vm.form.categoryCodes.length > 0
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "10px" } },
                        [
                          _c("BjDivider", [
                            _vm._v(_vm._s(_vm.$t("billingPage.CustomerTier"))),
                          ]),
                          _c(
                            "el-row",
                            { staticClass: "flex-align" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "48%" },
                                  attrs: {
                                    label: _vm.$t("billingPage.CurrentTier"),
                                  },
                                },
                                [
                                  _c("BjSelectLov", {
                                    attrs: {
                                      clearable: false,
                                      "option-list": _vm.clientTierList,
                                      placeholder: _vm.$t("chooseText"),
                                    },
                                    model: {
                                      value: _vm.form.currentTierId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "currentTierId", $$v)
                                      },
                                      expression: "form.currentTierId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "48%" },
                                  attrs: {
                                    label: _vm.$t("billingPage.EvaluatedTier"),
                                  },
                                },
                                [
                                  _c("BjInput", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.form.evaluatedTier,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "evaluatedTier", $$v)
                                      },
                                      expression: "form.evaluatedTier",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(
                            _vm.form.categoryCodes,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index },
                                [
                                  _c("BjDivider", [_vm._v(_vm._s(item.group))]),
                                  _c(
                                    "el-table",
                                    {
                                      ref: "multipleTable",
                                      refInFor: true,
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: item.billCategories,
                                        "header-cell-style": _vm.handerMethod,
                                        border: "",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "billCategoryName",
                                          label: _vm.$t(
                                            "billingPage.serviceType"
                                          ),
                                          align: "center",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "billingPage.chargeSection"
                                          ),
                                          align: "center",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.sectionMin
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .sectionMin
                                                            ) +
                                                            _vm._s(
                                                              scope.row.unit
                                                            )
                                                        ),
                                                        scope.row.sectionMax
                                                          ? _c("span", [
                                                              _vm._v(
                                                                " - " +
                                                                  _vm._s(
                                                                    scope.row
                                                                      .sectionMax
                                                                  ) +
                                                                  _vm._s(
                                                                    scope.row
                                                                      .unit
                                                                  )
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ])
                                                    : _c("span", [_vm._v("1")]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c(
                                        "el-table-column",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "billingPage.pricing"
                                            ),
                                            align: "center",
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "billingPage.pricing"
                                              ),
                                              align: "center",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _vm._v(
                                                        "$" +
                                                          _vm._s(
                                                            scope.row
                                                              .standardPrice
                                                          )
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        " ($" +
                                                          _vm._s(
                                                            scope.row.cost
                                                          ) +
                                                          ") "
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "billingPage.pricing"
                                              ),
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          staticClass:
                                                            "full-width",
                                                          attrs: {
                                                            controls: false,
                                                            onkeyup:
                                                              "this.value = this.value.replace(/[^\\d.-]/g,'');",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.price,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "price",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.price",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "prepend" },
                                                            [_vm._v("$")]
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "description",
                                          label: _vm.$t(
                                            "billingPage.description"
                                          ),
                                          align: "center",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "foot", staticStyle: { "margin-top": "20px" } },
            [
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.onCancel } },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onComfirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialogData", { ref: "dialogData", on: { submit: _vm.onSubmit } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }